export interface SongDifficultyData {
  code: string;
  labelKo: string;
  labelEn: string;
  format: 'color-drum' | 'color-staff' | 'classic-staff';
  abcKey: 'Easy' | 'Normal' | 'Hard';
  freeAccess: boolean;
  abcText?: string;
}

export interface Song {
  songId: string;
  categoryId: string;
  title: string;
  artist: string;
  thumbnail: string;
  previewAudio: string;
  playAudio: string;
  bpm: number;
  publishStatus: 'public' | 'private';
  registeredAt: string;
  contentVersion: string;
  audioStartOffset: number;
  difficulties: Record<'Easy' | 'Normal' | 'Hard', SongDifficultyData>;
}

export interface Category {
  categoryId: string;
  nameKo: string;
  nameEn: string;
  order: number;
}

export const CATEGORIES: Category[] = [];
export const SONGS: Song[] = [];
